var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"programs"},[_c('ProgramsThreeColumns',{attrs:{"cfgTitle":("" + (_vm.cfg.nameCategory)),"cfgCategory":("" + (_vm.cfg.category))}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }